import type { VoidFunctionComponent } from 'react';
import type Stripe from 'stripe-latest';
import { useGetCurrentPlan } from '../../../../hooks/subscriptions/useGetCurrentPlan';
import usePlans from '../plans/usePlans';
import Features from '../Features';
import SubscriptionBannerUpgrade from './SubscriptionBannerUpgrade';

export const SubscriptionBannerUpgradeWithDetails: VoidFunctionComponent = () => {
  const { data: subscriptionPlan } = useGetCurrentPlan();
  const { data: plans } = usePlans();
  if (!subscriptionPlan || !plans) {
    return null;
  }
  const businessProduct = plans.filter(plan => plan.type === 'BUSINESS')?.[0]?.prices[0]?.product as Stripe.Product;

  return (
    <SubscriptionBannerUpgrade hasUsedFreeTrial={subscriptionPlan?.hasUsedFreeTrial}>
      <Features product={businessProduct} asList={false} />
    </SubscriptionBannerUpgrade>
  );
};
